import styled, { css, keyframes } from 'styled-components'
import theme from 'styles/theme'
import { Title32 } from 'components/Typography'
import comma from 'assets/svg/icon.comma.svg'
import { rem } from 'polished'

export const BrandTickerWrapper = styled.aside`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
`

export const BrandTickerRow = styled.div`
  color: ${theme.colors.sagedark};
  height: 36px;
  margin-bottom: 10px;
  position: relative;
  width: 100%;

  ${theme.mediaQueries.medium} {
    height: 45px;
  }
`

const tickerAnimation = (x = 0) => keyframes`
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(${x}, 0, 0);
  }
`

const BrandTickerList2 = css`
  align-self: flex-end;
  animation-name: ${(props) => tickerAnimation(props.x || '9000px')};
  left: auto;
  right: 0;
`

export const BrandTickerList = styled(Title32)`
  animation: ${(props) => tickerAnimation(props.x || '-9000px')} 500s linear
    infinite;
  left: 0;
  line-height: 52px;
  position: absolute;
  top: 0;
  white-space: nowrap;
  font-size: ${rem(32)} !important;

  ${(props) => props.index % 2 !== 0 && BrandTickerList2}
`

export const BrandTickerListLabel = styled.span`
  &::after {
    background: url(${comma}) bottom no-repeat;
    background-size: contain;
    content: '';
    display: inline-block;
    height: 20px;
    margin: 0 12px 8px;
    vertical-align: bottom;
    width: 8px;

    ${theme.mediaQueries.medium} {
      width: 9px;
    }
  }
`

export const BrandTickerCTAContainer = styled.div`
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const BrandTickerCTADivider = styled.div`
  width: 75%;
  text-align: center;
  max-width: 500px;
`
